import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CheckIcon from '@mui/icons-material/Check';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

export const DoneIcon = styled(CheckIcon)(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.neutrals.beige1
}));

export const NextIcon = styled(EventAvailableIcon)(({ theme }) => ({
  fontSize: 18,
  color: theme.palette.brand.mediumGreen
}));

export const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5)
}));

export const DotColumn = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 4
}));
